export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export function parseQuantity(value) {
  const digits = String(value == null ? "" : value).replace(/\D/g, "");
  return digits === "" ? null : Number(digits);
}

export function formatQuantity(value) {
  const quantity = parseQuantity(value);
  return quantity == null
    ? ""
    : String(quantity).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
